module.exports = __webpack_public_path__ + "img/bg_pic3.5d130254.png";